import styled from "@emotion/styled";
import { Box, Grid } from "@mui/material";
import { doNotForwardIsMobile } from "./TimelineSliderStyle";
import { ZIndexLevels } from "../geoUtils";

/**
 * A container for the timeline with custom styles.
 */
export const TimelineContainer = styled( Box )( {
    backgroundColor: "transparent",
} );

const calculateTimelineMargin = ( isMobile: boolean, isRightBarExpanded: boolean, isLeftBarExpanded: boolean ) =>
{
    if ( isMobile ) return "0px 24px 0px 24px";
    if ( isRightBarExpanded ) return "0px 330px 0px 0px";
    if ( isLeftBarExpanded ) return "0px 0px 0px 400px";
    return "0px 0px 0px 0px";
};

export const doNotForwardMobileOrBarsExpanded = ( prop: string ) => prop !== "isMobile" && prop !== "isRightBarExpanded" && prop !== "isLeftBarExpanded" && prop !== "isVisible";

/**
 * A container for the inner part of the timeline with custom styles.
 */
export const TimelineInnerContainer = styled( Box, { shouldForwardProp: doNotForwardMobileOrBarsExpanded } )<{ isMobile: boolean, isRightBarExpanded: boolean, isLeftBarExpanded: boolean, isVisible: boolean }>( ( { isMobile, isRightBarExpanded, isLeftBarExpanded, isVisible } ) => ( {
    position: "absolute",
    bottom: "0px",
    paddingBottom: isMobile ? "35px" : "5px",
    visibility: "visible",
    right: 0,
    left: 0,
    backgroundColor: "transparent",
    margin: calculateTimelineMargin( isMobile, isRightBarExpanded, isLeftBarExpanded ),
    zIndex: ZIndexLevels.UIElement,
    transition: "opacity 0.3s ease, transform 0.3s ease, margin 0.3s ease",

    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0px)" : "translateY(-10px)",
    pointerEvents: isVisible ? "auto" : "none",
} ) );


/**
 * A container for the grid with custom styles.
 */
export const TimelineGridContainer = styled( Grid, { shouldForwardProp: doNotForwardIsMobile } )<{ isMobile: boolean }>( ( { isMobile } ) => ( {
    flexWrap: "nowrap",
    "& .MuiGrid-root.MuiGrid-item": {
        maxWidth: "100%",
        flexBasis: "100%",
        paddingRight: isMobile ? "0" : "16px",
        paddingLeft: isMobile ? "12px" : "24px",
    },
} ) );

/**
 * A container for the slider grid with custom styles.
 */
export const TimelineSliderGrid = styled( Grid, { shouldForwardProp: doNotForwardIsMobile } )<{ isMobile: boolean }>( ( { isMobile } ) => ( {
    display: "flex",
    flexDirection: "column",
    "@media (pointer: coarse)": {
        ".MuiSlider-root": {
            padding: isMobile ? "10px 0 3px 0" : "20px 0",
        },
    },
} ) );
